export const useDatosBancarios = () => {
  const validateBancarios = obj => {
    const errObj = {};
    const { formaDePago, tipoCuenta, banco, numeroCuenta } = obj;
    if (!formaDePago) { errObj.formaDePago = "Requerido"; }
    if (formaDePago === "2" && !banco) { errObj.banco = "Requerido"; }
    if (formaDePago === "2" && !tipoCuenta) { errObj.tipoCuenta = "Requerido"; }
    if (formaDePago === "2" && !numeroCuenta) { errObj.numeroCuenta = "Requerido"; }

    return errObj;
  }

  return { validateBancarios }
}